import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import {
  setAdminMode,
  toggleAdminMode,
  useAdminMode,
} from "../../redux/slices/adminSlice";
import { useQueryClient } from "react-query";
export const AdminConfigButton = () => {
  const { isAdminRole, setShowLoginModal } = useAuth();
  const { isAdminMode } = useAdminMode(); // This hook can be used to access admin mode state if needed
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const queryClient = useQueryClient();
  useEffect(
    function () {
      if (searchParams.get("adminMode")) {
        dispatch(setAdminMode(true));
        if (!isAdminRole) {
          setShowLoginModal(true); // Show login modal if the user is not an admin
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isAdminRole],
  );

  if (!isAdminRole) {
    return null; // If the user is not an admin, do not render the button
  }
  return (
    <div className="fixed bottom-0 left-6 z-[1000] flex gap-2">
      <button
        className={`flex h-12 w-12 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full border-none bg-white shadow-lg ${
          isAdminMode ? "text-blue-500 ring-4 ring-blue-500" : ""
        }`}
        aria-label="Admin Config"
        type="button"
        onClick={() => {
          if (isAdminMode) {
            queryClient.invalidateQueries("cityPage");
          }
          return dispatch(toggleAdminMode());
        }}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="12" cy="12" r="3" />
          <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 1 1-4 0v-.09a1.65 1.65 0 0 0-1-1.51 1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 1 1 0-4h.09a1.65 1.65 0 0 0 1.51-1 1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.65 1.65 0 0 0 1.82.33h.09A1.65 1.65 0 0 0 11 3.09V3a2 2 0 1 1 4 0v.09c0 .66.39 1.26 1 1.51a1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82v.09c.66.39 1.26 1.39 1.51 2.09H21a2 2 0 1 1 0 4h-.09c-.25.7-.85 1.7-1.51 2.09z" />
        </svg>
      </button>
      <div className="admin-config-area absolute bottom-5 left-[60px] flex flex-col gap-2"></div>
    </div>
  );
};
